import React, { useState, useRef, useEffect } from 'react';
import './PinLogin.css';
import { useAuth } from '../../contexts/AuthContext';

function PinLogin() {
  const [pin, setPin] = useState(['', '', '', '']);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

  useEffect(() => {
    // Focus first input on mount
    inputRefs[0].current?.focus();
  }, []);

  const handleChange = (index, value) => {
    // Only allow single digit
    if (!/^\d?$/.test(value)) return;

    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);
    setError('');

    // Auto-focus next input if digit entered
    if (value && index < 3) {
      inputRefs[index + 1].current?.focus();
    }

    // Auto-submit when all 4 digits entered
    if (value && index === 3 && newPin.every(digit => digit !== '')) {
      handleSubmit(newPin.join(''));
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace - move to previous input
    if (e.key === 'Backspace' && !pin[index] && index > 0) {
      inputRefs[index - 1].current?.focus();
    }
  };

  const handleSubmit = async (pinValue) => {
    if (pinValue.length !== 4) {
      setError('PIN måste vara 4 siffror');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await login(pinValue);
      // Success - AuthContext will update and show main app
    } catch (err) {
      setLoading(false);
      setPin(['', '', '', '']);  // Clear all PIN boxes on error
      inputRefs[0].current?.focus();  // Focus first input

      if (err.response) {
        if (err.response.status === 429) {
          setError(err.response.data.detail || 'För många försök. Försök igen senare.');
        } else if (err.response.status === 401) {
          setError(err.response.data.detail || 'Felaktig PIN-kod');
        } else {
          setError('Ett fel uppstod. Försök igen.');
        }
      } else {
        setError('Kan inte ansluta till servern');
      }
    }
  };

  return (
    <div className="pin-login-container">
      <div className="pin-login-card">
        <h1>Besöksregistrering</h1>
        <p className="pin-login-subtitle">Ange 4-siffrig PIN-kod</p>

        <div className="pin-boxes-container">
          {[0, 1, 2, 3].map((index) => (
            <input
              key={index}
              ref={inputRefs[index]}
              type="password"
              inputMode="numeric"
              pattern="\d"
              maxLength="1"
              value={pin[index]}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              disabled={loading}
              className={`pin-box ${error ? 'error' : ''}`}
              autoComplete="off"
            />
          ))}
        </div>

        {error && <div className="pin-error">{error}</div>}

        {loading && <div className="pin-loading">Verifierar...</div>}
      </div>
    </div>
  );
}

export default PinLogin;
